import Preloader from "components/Preloader/Preloader";
import AdminCartElement from "features/admin/Orders/components/AdminCartElement";
import {
  Title,
  NoProductsInOrder,
  OrderPreview,
  Items,
} from "features/admin/Orders/components/OrderProducts";
import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components/macro";
import {
  selectAdminProjectElements,
  selectAdminProjectElementsLoading,
} from "../adminGallerySlice";

interface ProjectProductsProps {
  noProductsMessage: string;
  removeItemHandler: any;
}

const ProjectProducts: React.FC<ProjectProductsProps> = ({
  noProductsMessage,
  removeItemHandler,
}) => {
  const projectElements = useSelector(selectAdminProjectElements);
  const isLoading = useSelector(selectAdminProjectElementsLoading);

  return (
    <OrderPreview>
      <Title>Поръчани климатици</Title>
      {isLoading ? (
        <Preloader />
      ) : projectElements?.length > 0 ? (
        <Items>
          {projectElements.map((item, idx) => {
            return (
              <AdminCartElement
                key={idx}
                item={item}
                removeItemHandler={removeItemHandler}
              />
            );
          })}
        </Items>
      ) : (
        <NoProductsInOrder>{noProductsMessage}</NoProductsInOrder>
      )}
    </OrderPreview>
  );
};

export default ProjectProducts;
